import { render, staticRenderFns } from "./newsListDetails.vue?vue&type=template&id=271f8bd5&scoped=true"
import script from "./newsListDetails.vue?vue&type=script&lang=js"
export * from "./newsListDetails.vue?vue&type=script&lang=js"
import style0 from "./newsListDetails.vue?vue&type=style&index=0&id=271f8bd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f8bd5",
  null
  
)

export default component.exports